<template>
  <div>
    <div class="title">
      推广人数 <span>{{ first + second }}</span> 人
    </div>
    <div class="tab-list">
      <div class="item" :class="index === 0 ? 'on' : ''" @click="changIndex(0)">
        一级({{ first }})
      </div>
      <div class="item" :class="index === 1 ? 'on' : ''" @click="changIndex(1)">
        二级({{ second }})
      </div>
    </div>
    <div class="people-box">
      <div class="people" v-for="item of UserList" :key="item.uid">
        <div class="img">
          <img :src="item.avatar" alt="" />
        </div>
        <div class="name">
          <div class="tip">{{ item.nickname }}</div>
          <div class="time">加入时间: {{ item.time }}</div>
        </div>
        <div class="sale">
          <div>
            <span>{{ item.childCount }}</span
            >人
          </div>
          <div>{{ item.orderCount }}单</div>
          <div>{{ item.numberCount ? item.numberCount : 0 }}元</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSpreadUser } from "@api/user";
export default {
  name: "BusinessTotal",
  data() {
    return {
      param: {
        grade: 0,
        keyword: "",
        limit: 15,
        page: 1,
        sort: ""
      },
      index: 0,
      UserList: [],
      first: "",
      second: ""
    };
  },
  created() {
    this.spreadUserList();
  },
  methods: {
    spreadUserList() {
      getSpreadUser(this.param).then(res => {
        this.UserList = res.data.list;
        this.first = res.data.total;
        this.second = res.data.totalLevel;
      });
    },
    changIndex(index) {
      if (this.index === index) return;
      this.index = index;
      this.param.grade = index;
      this.spreadUserList();
    }
  }
};
</script>

<style lang="stylus" scoped>
.title
  text-align center
  font-size 16px
  color #666
  border-bottom 1px solid #ccc
  padding-bottom 10px
  span
    color red
    font-size 20px
.tab-list
  height 40px
  line-height 40px
  display flex
  text-align center
  border-bottom 1px solid #ccc
  font-size 14px
  .item
    width 100px
    position relative
    cursor pointer
    &:first-child::after
      content ''
      display inline-block
      position absolute
      width 1px
      height 20px
      top 10px
      right 0
      background #ccc
  .on
    color #e93323
    border-bottom 2px solid #e93323
.people-box
  padding 10px
  .people
    display flex
    .img
      width 70px
      height 70px
      border-radius 50%
      border 1px solid #ccc
      overflow hidden
      img
        width 100%
        height 100%
    .name
      margin-left 15px
      .tip
        color #666
        font-size 12px
        margin-top 10px
      .time
        color #999
        font-size 12px
        margin-top 15px
    .sale
      margin-left 100px
      display flex
      margin-top 20px
      div
        width 60px
        text-align center
        >span
          color #e93323
</style>
